import type { Type } from "arktype";

/**
 * Check if the field is optional
 */
export function isRequired(fieldSchema: Type, key: string) {
	const requiredConstraints = fieldSchema.select({
		boundary: "shallow",
		kind: "required",
	});

	return requiredConstraints.filter((c) => c.key === key).length > 0;
}

/**
 * Check if the field is optional
 */
export function isOptional(fieldSchema: Type, key: string) {
	const optionalConstraints = fieldSchema.select({
		boundary: "shallow",
		kind: "optional",
	});

	return optionalConstraints.filter((c) => c.key === key).length > 0;
}

/**
 * Retrieve the maxLength rule from the schema
 */
export function getMaxLength(fieldSchema: Type) {
	const maxLengthConstraints = fieldSchema.select({
		kind: "maxLength",
	});

	if (maxLengthConstraints.length === 0) {
		return null;
	}

	return maxLengthConstraints.reduce((max, constraint) => {
		if (max === 0 || constraint.rule < max) {
			return constraint.rule;
		}

		return max;
	}, 0);
}
